import React, { ReactElement } from "react";
import { Redirect } from "react-router-dom";

import { RouteEnum } from "core/enum/route.enum";
import { UserRoles } from "core/enum/user-roles.enum";
import { useSelectIsAuthenticated } from "store/auth/auth.selectors";
import { RoleGuard } from "./RoleGuard";

interface IProps {
  children: ReactElement;
  auth?: boolean;
  roles?: UserRoles[];
}

const ProtectedRoute = ({ children, auth, roles }: IProps) => {
  const isAuthenticated = useSelectIsAuthenticated();

  if (!auth) return children;

  if (!isAuthenticated) return <Redirect to={RouteEnum.Login} />;

  if (roles && roles.length > 0)
    return <RoleGuard roles={roles}>{children}</RoleGuard>;

  return children;
};

export default ProtectedRoute;
